import React, { Suspense, useMemo } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";
import Favicon from "react-favicon";
import Header from "../src/include/Header";
import ScrollToTopOnRouteChange from "./include/ScrollToTop";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Loader from "./components/Loader";
import "./App.css";
import { useApi } from './hooks/useApi';
import { endpoints } from './services/api'; 

const HomePage = React.lazy(() => import ("./pages/home"));
const AboutPage = React.lazy(() => import ("./pages/About"));
const VisionMissionPage = React.lazy(() => import ("./pages/vision-mission"));
const InfrastructurePage = React.lazy(() => import ("./pages/Infrastructure"));
const ManagementPage = React.lazy(() => import ("./pages/Management"));
const TeachersListPage = React.lazy(() => import ("./pages/TeachersList"));
const AcademicPage = React.lazy(() => import ("./pages/Academic"));
const CurriculumPage = React.lazy(() => import ("./pages/Curriculum"));
const SchoolFeesPage = React.lazy(() => import ("./pages/SchoolFees"));
const PromotionRulesPage = React.lazy(() => import ("./pages/PromotionRules"));
const StudentCarePage = React.lazy(() => import ("./pages/StudentCare"));
const AdmissionPage = React.lazy(() => import ("./pages/Admission"));
const EventsPage = React.lazy(() => import ("./pages/Events"));
const AnnouncementsPage = React.lazy(() => import ("./pages/Announcements"));
const PhotoGalleryPage = React.lazy(() => import ("./pages/PhotoGallery"));
const PublicationsPage = React.lazy(() => import ("./pages/Publications"));
const AchievementsPage = React.lazy(() => import ("./pages/Achievements"));
const ResultsPage = React.lazy(() => import ("./pages/Results"));
const FacilituesPage = React.lazy(() => import ("./pages/Facilitues"));
const AboutTheSchoolPage = React.lazy(() => import ("./pages/AboutTheSchool"));
const FaqPage = React.lazy(() => import ("./pages/Faq"));
const Careers = React.lazy(() => import ("./pages/Careers"));
const TermsandPolicies = React.lazy(() => import ("./pages/TermsandPolicies"));
const Alumni = React.lazy(() => import ("./pages/Alumni"));
const TeachersAchievements = React.lazy(() => import ("./pages/TeachersAchievements"));
const SuccessStoriesPage = React.lazy(() => import ("./pages/SuccessStories"));
const PrivacyPage = React.lazy(() => import ("./pages/Privacy"));
const Accessibility = React.lazy(() => import ("./pages/AccessibilityPage"));
const ContactPage = React.lazy(() => import ("./pages/contact"));


function App() {

  const { data: settingsData } = useApi(endpoints.settings);
  
  if (settingsData) {
      const root = document.documentElement;
      root.style.setProperty('--blue-color', settingsData.settings.primary_color);
      root.style.setProperty('--light-blue-color', settingsData.settings.secondary_color);
    }

  const scrollTopSvgPath = useMemo(
    () =>
      "M17.71,11.29l-5-5a1,1,0,0,0-.33-.21,1,1,0,0,0-.76,0,1,1,0,0,0-.33.21l-5,5a1,1,0,0,0,1.42,1.42L11,9.41V17a1,1,0,0,0,2,0V9.41l3.29,3.3a1,1,0,0,0,1.42,0A1,1,0,0,0,17.71,11.29Z",
    []
  );

  return (
    <div className="App">
      <Favicon url={process.env.PUBLIC_URL + "/images/favicon.png"} />
      <HelmetProvider>
        <Helmet>
          <title>GAET</title>
          <link
            rel="icon"
            href={process.env.PUBLIC_URL + "/images/favicon.png"}
          />
        </Helmet>
        <Suspense fallback={<div><Loader /></div>}>        
          <Router>
            <ScrollToTopOnRouteChange />
            <Header />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/about-the-school" element={<AboutTheSchoolPage />} />
              <Route path="/vision-mission" element={<VisionMissionPage />} />
              <Route path="/infrastructure" element={<InfrastructurePage />} />
              <Route path="/management" element={<ManagementPage />} />
              <Route path="/academic" element={<AcademicPage />} />
              <Route path="/school-fees" element={<SchoolFeesPage />} />
              <Route path="/promotion-rules" element={<PromotionRulesPage />} />
              <Route path="/student-care" element={<StudentCarePage />} />
              <Route path="/exam-time-table" element={<TeachersListPage />} />
              <Route path="/admission" element={<AdmissionPage />} />
              <Route path="/events-announcements" element={<AnnouncementsPage />} />
              <Route
                path="/photogallery"
                element={<PhotoGalleryPage />}
              />
              <Route path="/achievements" element={<AchievementsPage />} />
              <Route path="/success-stories" element={<SuccessStoriesPage />} />
              <Route path="/results" element={<ResultsPage />} />
              <Route
                path="/teachers-achievements"
                element={<TeachersAchievements />}
              />
              <Route path="/alumni" element={<Alumni />} />
              <Route path="/facilities" element={<FacilituesPage />} />
              <Route path="/faq" element={<FaqPage />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/termsandpolicies" element={<TermsandPolicies />} />
              {/* uses less components*/}
              <Route path="/events" element={<EventsPage />} />
              <Route path="/curriculum" element={<CurriculumPage />} />
              <Route path="/downloads" element={<PublicationsPage />} />
              <Route path="/teachers-list" element={<TeachersListPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/accessibility" element={<Accessibility />} />
              <Route path="/contact-us" element={<ContactPage />} />
            </Routes>
          </main>
          </Router>
        </Suspense>
      </HelmetProvider>
      <ScrollToTop smooth viewBox="0 0 24 24" svgPath={scrollTopSvgPath} />
    </div>
  );
}
export default App;
